import styles from "@/components/pages/beats/styles/setting-header.module.scss";
import Image from "next/image";
import settingsIcon from "@/assets/icons/generating-icon-red.svg";
import { MAX_EFFECTS } from "@/components/pages/beats/data/beats-effects.data";

const EffectsContainerHeader = () => {
  const description = `Add up to ${MAX_EFFECTS} sequential effects to rearrange your song`;

  return (
    <div className={styles.settings_block_header}>
      <div className={styles.icon_title_wrapper}>
        <Image src={settingsIcon} alt={""} />
        <div className={styles.setting_header_text}>Effects</div>
      </div>
      <div className={styles.description_text}>{description}</div>
    </div>
  );
};

export default EffectsContainerHeader;
